// Pedidos.js
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getPedidos } from "utils/LaravelApi/LaravelAPI";

const Pedidos = ({ user }) => {

  let history = useHistory();

  const [pedidos, setPedidos] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await getPedidos({
          email: user.email,
          per_page: 15,
          page: page,
        });
        
        // Verificamos que la respuesta tenga la estructura esperada
        if (response.data && response.data.items) {
          setPedidos(response.data.items);
          setTotalItems(response.data.pagination.total_items);
          setTotalPages(response.data.pagination.total_pages);
        } else {
          throw new Error("Formato de respuesta inesperado");
        }
      } catch (err) {
        setError("Error al cargar los pedidos. Por favor, inténtalo de nuevo.");
        console.error("Error fetching pedidos:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPedidos();
  }, [user.email, page]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const tableHeaderRowStyle = {
    borderTop: "1px solid #000",
    borderBottom: "1px solid #000",
  };

  const tableHeaderCellStyle = {
    padding: "10px",
    textAlign: "left",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "20px",
  };

  const cellStyle = {
    padding: "8px",
    borderBottom: "1px solid #ddd",
  };

  const linkStyle = {
    color: "#0066cc",
    textDecoration: "underline",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const paginationStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
    padding: "10px",
    backgroundColor: "#f8f9fa",
    borderRadius: "5px",
  };

  const paginationButtonStyle = {
    padding: "8px 15px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.2s",
  };

  const disabledButtonStyle = {
    ...paginationButtonStyle,
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
    opacity: 0.6,
  };

  const pageInfoStyle = {
    fontWeight: "bold",
    color: "#495057",
  };

  return (
    <div style={{ padding: "20px", backgroundColor: "white", borderRadius: "8px", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
      <h2 style={{ marginBottom: "20px", color: "#333", borderBottom: "2px solid #eee", paddingBottom: "10px" }}>
        Historial de Pedidos
      </h2>
      
      {loading && (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>Cargando pedidos...</p>
        </div>
      )}
      
      {error && (
        <div style={{ color: "#dc3545", padding: "10px", backgroundColor: "#f8d7da", borderRadius: "4px", marginBottom: "20px" }}>
          {error}
        </div>
      )}
      
      {!loading && !error && pedidos.length === 0 && (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>No se encontraron pedidos para este usuario.</p>
        </div>
      )}
      
      {!loading && !error && pedidos.length > 0 && (
        <>
          <table style={tableStyle}>
            <thead>
              <tr style={tableHeaderRowStyle}>
                <th style={tableHeaderCellStyle}>Orden</th>
                <th style={tableHeaderCellStyle}>Fecha</th>
                <th style={tableHeaderCellStyle}>Estado del Pedido</th>
              </tr>
            </thead>
            <tbody>
              {pedidos.map((pedido, index) => (
                <tr key={index}>
                  <td
                    style={{ ...cellStyle, ...linkStyle }}
                    onClick={() => {
                      history.push(`pedido/${pedido.uuid}`);
                    }}
                  >
                    #{pedido.id}
                  </td>
                  <td style={cellStyle}>{pedido.fecha}</td>
                  <td style={cellStyle}>
                    <span style={{
                      padding: "4px 8px",
                      borderRadius: "12px",
                      backgroundColor: pedido.estado === "Completado" ? "#d4edda" : 
                                       pedido.estado === "Pendiente" ? "#fff3cd" : 
                                       pedido.estado === "Cancelado" ? "#f8d7da" : "#e2e3e5",
                      color: pedido.estado === "Completado" ? "#155724" : 
                             pedido.estado === "Pendiente" ? "#856404" : 
                             pedido.estado === "Cancelado" ? "#721c24" : "#383d41"
                    }}>
                      {pedido.estado}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          <div style={paginationStyle}>
            <button 
              style={page === 1 ? disabledButtonStyle : paginationButtonStyle}
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              Anterior
            </button>
            
            <div style={pageInfoStyle}>
              Página {page} de {totalPages} | 
              Mostrando {(page - 1) * 15 + 1} - {Math.min(page * 15, totalItems)} de {totalItems} pedidos
            </div>
            
            <button 
              style={page === totalPages ? disabledButtonStyle : paginationButtonStyle}
              onClick={() => handlePageChange(page + 1)}
              disabled={page === totalPages}
            >
              Siguiente
            </button>
          </div>
          
          <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              const pageNumber = i + 1;
              const isCurrent = page === pageNumber;
              
              return (
                <button
                  key={pageNumber}
                  style={{
                    ...paginationButtonStyle,
                    backgroundColor: isCurrent ? "#343a40" : "#6c757d",
                    margin: "0 3px",
                    padding: "5px 10px",
                    minWidth: "32px",
                  }}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            })}
            
            {totalPages > 5 && (
              <span style={{ margin: "0 10px", lineHeight: "30px" }}>...</span>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Pedidos;